module.exports = __webpack_public_path__ + "static/media/interbank.5d2faf40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pay-methods/interbank.png
// module id = 574
// module chunks = 0